import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Footer() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const legalTerms = [{
    title: 'Términos y Condiciones',
    content: <div className="space-y-3 md:space-y-4 text-sm opacity-80" data-id="element-99">
          <p data-id="element-100">
            Al adquirir "Mente Clara, Mamá Facturando", un producto digital de{' '}
            <strong data-id="element-101">Vitaly Forms</strong>, aceptas los siguientes términos y
            condiciones de uso.
          </p>
          <p data-id="element-102">
            Este producto es para uso personal y exclusivo del comprador. Queda
            estrictamente prohibida su reproducción, distribución, venta o
            alteración total o parcial sin el consentimiento expreso y por
            escrito de <strong data-id="element-103">Vitaly Forms</strong>.
          </p>
          <p data-id="element-104">
            El acceso al material digital se otorga de manera inmediata tras la
            confirmación del pago. Te comprometes a proporcionar información
            veraz durante el proceso de compra. <strong data-id="element-105">Vitaly Forms</strong> se
            reserva el derecho de modificar estos términos en cualquier momento.
          </p>
        </div>
  }, {
    title: 'Política de Privacidad',
    content: <div className="space-y-3 md:space-y-4 text-sm opacity-80" data-id="element-106">
          <p data-id="element-107">
            En <strong data-id="element-108">Vitaly Forms</strong> respetamos tu privacidad y
            protegemos tus datos personales. La información recopilada durante
            tu compra (nombre, correo electrónico) se utiliza exclusivamente
            para procesar tu pedido y enviarte el material adquirido.
          </p>
          <p data-id="element-109">
            <strong data-id="element-110">Vitaly Forms</strong> no comparte, vende ni alquila tu
            información personal a terceros bajo ninguna circunstancia. Los
            pagos son procesados a través de pasarelas seguras y no almacenamos
            datos de tus tarjetas de crédito.
          </p>
          <p data-id="element-111">
            Al realizar la compra, aceptas recibir correos electrónicos
            transaccionales de <strong data-id="element-112">Vitaly Forms</strong> relacionados con tu
            pedido y ocasionalmente información relevante sobre actualizaciones
            del producto.
          </p>
        </div>
  }, {
    title: 'Aviso Legal / Disclaimer',
    content: <div className="space-y-3 md:space-y-4 text-sm opacity-80" data-id="element-113">
          <p data-id="element-114">
            La información contenida en "Mente Clara, Mamá Facturando",
            publicado por <strong data-id="element-115">Vitaly Forms</strong>, tiene fines
            estrictamente educativos e informativos. No constituye consejo
            médico, psicológico ni psiquiátrico profesional.
          </p>
          <p data-id="element-116">
            Las técnicas compartidas están basadas en principios generales de
            productividad y bienestar, pero los resultados pueden variar
            significativamente de una persona a otra dependiendo de su situación
            particular, consistencia y aplicación. <strong data-id="element-117">Vitaly Forms</strong>{' '}
            no garantiza resultados específicos.
          </p>
          <p data-id="element-118">
            Si experimentas problemas graves de salud mental, estrés crónico o
            ansiedad, te recomendamos encarecidamente buscar la ayuda de un
            profesional de la salud cualificado.
          </p>
        </div>
  }, {
    title: 'Política de Reembolso',
    content: <div className="space-y-3 md:space-y-4 text-sm opacity-80" data-id="element-119">
          <p data-id="element-120">
            <strong data-id="element-121">Vitaly Forms</strong> ofrece una garantía de satisfacción
            total de 7 días naturales a partir de la fecha y hora exacta de tu
            compra.
          </p>
          <p data-id="element-122">
            Si aplicas las técnicas descritas en el manual y consideras que no
            has obtenido ningún beneficio en tu claridad mental, puedes
            solicitar el reembolso completo del importe pagado contactando a{' '}
            <strong data-id="element-123">Vitaly Forms</strong> por correo electrónico dentro del
            plazo establecido.
          </p>
          <p data-id="element-124">
            Una vez procesado el reembolso por <strong data-id="element-125">Vitaly Forms</strong>,
            perderás el derecho de uso sobre el material digital. Pasados los 7
            días de garantía, no se aceptarán solicitudes de devolución bajo
            ninguna circunstancia debido a la naturaleza digital del producto.
          </p>
        </div>
  }];
  return <footer className="w-full bg-[#2D2D2D] text-white px-4 md:px-6 py-6 md:py-16" data-id="element-126">
      <div className="max-w-3xl mx-auto text-center" data-id="element-127">
        <h3 className="font-['Playfair_Display'] text-2xl font-bold mb-2" data-id="element-128">
          Mente Clara, Mamá Facturando
        </h3>

        <p className="text-xs opacity-40 mb-1" data-id="element-129">Un producto de</p>
        <p className="text-sm font-bold text-[#D4A853] mb-3 md:mb-4" data-id="element-130">
          Vitaly Forms
        </p>

        <p className="text-sm opacity-60 mb-5 md:mb-12" data-id="element-131">
          © {new Date().getFullYear()} Vitaly Forms. Todos los derechos
          reservados.
        </p>

        <div className="space-y-2 md:space-y-3 text-left" data-id="element-132">
          {legalTerms.map((term, index) => <div key={index} className="border border-white/10 rounded-lg overflow-hidden" data-id="element-133">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-4 md:px-6 py-3 md:py-4 flex items-center justify-between text-left hover:bg-white/5 transition-colors" data-id="element-134">
                <span className="font-medium text-sm text-white/90" data-id="element-135">
                  {term.title}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} data-id="element-136">
                  <ChevronDownIcon className="w-5 h-5 text-[#E8734A] flex-shrink-0" data-id="element-137" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-138">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden bg-black/20" data-id="element-139">
                    <div className="px-4 md:px-6 py-4 md:py-5" data-id="element-140">
                      {term.content}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </footer>;
}